import { Component, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { TranslationService } from 'src/app/common/services/translation.service';

@Component({
  selector: 'taly-business-with-taly',
  templateUrl: './business-with-taly.component.html',
  styleUrls: ['./business-with-taly.component.scss']
})
export class BusinessWithTalyComponent implements OnInit{

  transferSignal = inject(SharedSignalsService);
  textDirection : any;

  benefits:any[] = [];

  constructor(public translationService: TranslationService){
    effect(() => { 
      this.textDirection = this.transferSignal.textDirection();   
      this.setBenefits()
    });
  }

  ngOnInit(): void {

    this.setBenefits();
    
  }

  setBenefits(){
    this.benefits = [
      {
        icon : "assets/images/Order.svg",
        value : "+41%",
        desc :  this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_1')
      },
      {
        icon : "assets/images/Increase.svg",
        value : "+30%",
        desc :  this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_2')
      },
      {
        icon : "assets/images/Conversion-rate.svg",
        value : "+19%",
        desc :  this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_3')
      },
      {
        icon : "assets/images/Money.svg",
        value : "-20%",
        desc :  this.translationService.getLabelValue('LEARN_MORE_PAGE.COUNT_DESC_4')
      }
    ]
  }

}
